import { Analytics } from '@vercel/analytics/react';
import Router from './router';

function App() {
  return (
    <>
      <Router />
      <Analytics />
    </>
  );
}

export default App;
